import { SvgIcon } from '@mui/material';
import { CSSProperties } from 'react';

export const DelayedTaskTimeIcon = (fill: CSSProperties['fill']) => (
  <SvgIcon>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 7H13V11.9764L15.774 15.3668L14.226 16.6332L11 12.6903V7Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8235 4C7.52129 4 4 7.56296 4 12C4 16.437 7.52129 20 11.8235 20V22C6.37957 22 2 17.5041 2 12C2 6.49591 6.37957 2 11.8235 2C12.3701 2 12.8833 2.01395 13.4062 2.10156L13.1388 4.1124C12.7115 4.0385 12.2721 4 11.8235 4Z"
        fill={fill}
      />
      <path d="M11 18H13V22H11V18Z" fill={fill} />
      <path d="M22 18V20H16V18H22Z" fill={fill} />
      <path d="M18 16H20V22H18V16Z" fill={fill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7856 4.03801C12.5274 4.01289 12.2654 4 12 4V2C12.3302 2 12.6569 2.01603 12.9794 2.04742L12.7856 4.03801ZM15.7712 4.94262C15.3133 4.69736 14.8289 4.49548 14.3235 4.34236L14.9034 2.42828C15.5364 2.62006 16.1427 2.87281 16.7155 3.17959L15.7712 4.94262ZM18.1847 6.9252C17.8518 6.52006 17.4799 6.14816 17.0748 5.81529L18.3445 4.26999C18.8502 4.68554 19.3145 5.14977 19.73 5.65554L18.1847 6.9252ZM19.6576 9.67651C19.5045 9.17111 19.3026 8.68675 19.0574 8.22883L20.8204 7.28452C21.1272 7.85729 21.3799 8.46361 21.5717 9.0966L19.6576 9.67651ZM19.962 12.8279C19.962 12.5625 19.9871 11.4726 19.962 11.2144L21.9526 11.0206C21.984 11.3431 21.9526 13.0938 21.9526 13.1875L19.962 12.8279Z"
        fill={fill}
      />
    </svg>
  </SvgIcon>
);

export const ExtendedTaskTimeIcon = (fill: CSSProperties['fill']) => (
  <SvgIcon>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2 7.99998H4V16H2V7.99998Z" fill={fill} />
      <path d="M20 7.99998H22V16H20V7.99998Z" fill={fill} />
      <path d="M6 11H8V13H6V11Z" fill={fill} />
      <path d="M10 11H12V13H10V11Z" fill={fill} />
      <path d="M12 11H17V13H12V11Z" fill={fill} />
      <path
        d="M19.6569 12L18.2427 13.4142L14.0001 9.17154L15.4143 7.75732L19.6569 12Z"
        fill={fill}
      />
      <path
        d="M18.2426 10.5858L19.6569 12L15.4142 16.2426L14 14.8284L18.2426 10.5858Z"
        fill={fill}
      />
    </svg>
  </SvgIcon>
);

export const ReducedTaskTimeIcon = (fill: CSSProperties['fill']) => (
  <SvgIcon>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0288 3.99452C18.3065 4.18101 19.6875 5.10937 20.2197 6.01401L18.656 7.26091C18.375 6.82314 17.1345 5.8031 16.9138 5.65486L18.0288 3.99452ZM12.9996 21.9458C12.6507 21.9619 12.2992 21.9594 11.9465 21.9375L12.0705 19.9413C12.3507 19.9587 12.6301 19.9608 12.9075 19.948L12.9996 21.9458ZM20.2197 6.01401C20.4273 6.27424 20.6018 6.4556 20.7813 6.73437C21.1788 7.35213 21.4437 7.9449 21.6094 8.28125L19.9034 9.10938C19.7713 8.84118 19.2806 8.15723 19.1186 7.90549C18.9756 7.68331 18.8213 7.46813 18.656 7.26091L20.2197 6.01401ZM17.0362 20.8689C16.4129 21.189 15.7557 21.4426 15.0765 21.6241L14.5603 19.6918C15.1015 19.5473 15.6254 19.3451 16.1225 19.0898L17.0362 20.8689ZM22.111 9.91751C22.2804 10.6436 22.3681 11.3928 22.3672 12.1511L20.3672 12.1489C20.3679 11.5463 20.2982 10.9503 20.1633 10.372L22.111 9.91751ZM20.2626 18.2135C19.824 18.7705 19.33 19.273 18.7918 19.7155L17.5215 18.1708C17.9499 17.8185 18.3427 17.4189 18.6913 16.9763L20.2626 18.2135ZM22.1055 14.3845C22.0202 14.7457 21.9137 15.1055 21.7853 15.4624C21.6653 15.7958 21.529 16.1191 21.3775 16.4315L19.5779 15.5589C19.6986 15.31 19.8074 15.052 19.9034 14.7853C20.0061 14.4998 20.0911 14.2126 20.159 13.9249L22.1055 14.3845Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 7H13V11.9764L15.774 15.3668L14.226 16.6332L11 12.6903V7Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8235 4C7.52129 4 4 7.56296 4 12C4 16.437 7.52129 20 11.8235 20V22C6.37957 22 2 17.5041 2 12C2 6.49591 6.37957 2 11.8235 2C12.4662 2 13.0949 2.06295 13.704 2.1832L13.3059 4.14322C12.8263 4.04924 12.3308 4 11.8235 4Z"
        fill={fill}
      />
      <path d="M11 18H13V22H11V18Z" fill={fill} />
      <path
        d="M16.5307 3.00002L18.513 3.26534L17.8125 8.625L15.8302 8.35969L16.5307 3.00002Z"
        fill={fill}
      />
      <path
        d="M16.2654 4.98244L16.5307 3.00002L21.5 3.6875L21.2347 5.66982L16.2654 4.98244Z"
        fill={fill}
      />
    </svg>
  </SvgIcon>
);
